// services/StatisticsService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

// Tous les appels acceptent les mêmes filtres facultatifs (snake_case), voir
// useYearFilters().params : academic_year_id, semester_id, department_id,
// level_id, class_id, group_id, subject_id, exam_id, student_status, from, to.
// Côté serveur, un enseignant est de toute façon limité à ses étudiants et à
// ses matières, quels que soient les filtres envoyés.

export function getOverviewStatistics(params = {}) {
    return api.get(ENDPOINTS.STATISTICS.OVERVIEW, { params });
}
export function getAttemptsTimeline(days = 14, params = {}) {
    return api.get(ENDPOINTS.STATISTICS.TIMELINE, { params: { ...params, days } });
}
export function getScoreDistribution(params = {}) {
    return api.get(ENDPOINTS.STATISTICS.SCORE_DISTRIBUTION, { params });
}
export function getStatisticsBySubject(params = {}) {
    return api.get(ENDPOINTS.STATISTICS.BY_SUBJECT, { params });
}
// by : "class" | "department" | "level" | "exam"
export function getStatisticsBreakdown(by, params = {}) {
    return api.get(ENDPOINTS.STATISTICS.BREAKDOWN, { params: { ...params, by } });
}
export function getModuleAverages(params = {}) {
    return api.get(ENDPOINTS.STATISTICS.MODULE_AVERAGES, { params });
}
export function getExamStatistics(examId) {
    return api.get(ENDPOINTS.STATISTICS.EXAM(examId));
}
export function getAcademicYearStatistics(academicYearId, params = {}) {
    return api.get(ENDPOINTS.STATISTICS.ACADEMIC_YEAR(academicYearId), { params });
}

export function getYearOutcomes(academicYearId, params = {}) {
    return api.get(ENDPOINTS.STATISTICS.YEAR_OUTCOMES(academicYearId), { params });
}
export function setYearOutcome(academicYearId, studentId, payload) {
    return api.put(ENDPOINTS.STATISTICS.YEAR_OUTCOME(academicYearId, studentId), payload);
}

// Options des filtres, déjà limitées au rôle du compte (enseignant : ses classes
// et matières ; étudiant : les siennes).
export function getFilterOptions() {
    return api.get(ENDPOINTS.STATISTICS.FILTER_OPTIONS);
}
// Statistiques personnelles de l'étudiant connecté (résultats publiés).
export function getMyStatistics(params = {}) {
    return api.get(ENDPOINTS.STATISTICS.ME, { params });
}